<listview #taskGrid [config]="config" class="page-layout workpackages-table simple left-sidebar inner-sidebar inner-scroll">
    <ng-template customCell for="Auftraggeber" let-dataItem="dataItem">
        {{ dataItem.FieldValuesAsText?.Auftraggeber }} {{ dataItem.FieldValuesAsText?.Auftraggeber_x005f_x003a_x005f_Title2 }} {{ dataItem.FieldValuesAsText?.Auftraggeber_x005f_x003a_x005f_Title3 }}
    </ng-template>
</listview>
